import { useState, useEffect } from "react";
import CloseIcon from "../assets/crossIcon.svg";
import { ICDservices } from "../services/ICDservices";
import * as ECT from "@whoicd/icd11ect";
import "@whoicd/icd11ect/style.css";

const ECTDiagnosisSearch = ({
  setOpen,
  setFieldValue,
  setPrimaryDiagnosisDetails,
  setSecondaryDiagnosisDetails,
  primary,
}) => {
  const iNo = 1;

  useEffect(() => {
    let isMounted = true;
    let interval;

    const configureECT = async () => {
      const settings = {
        apiServerUrl: "https://id.who.int",
        apiSecured: true,
        autoBind: false,
      };

      const callbacks = {
        selectedEntityFunction: (selectedEntity) => {
          if (primary) {
            setFieldValue("primaryDiagnosisICDcode", selectedEntity.code);
            setFieldValue("primaryDiagnosisDetails", selectedEntity.title);
            setPrimaryDiagnosisDetails({
              ...selectedEntity,
              value: selectedEntity.title,
            });
          } else {
            setFieldValue("secondaryDiagnosisICDcode", selectedEntity.code);
            setFieldValue("secondaryDiagnosisDetails", selectedEntity.title);
            setSecondaryDiagnosisDetails({
              ...selectedEntity,
              value: selectedEntity.title,
            });
          }

          ECT.Handler.clear(iNo);
          setOpen(false);
        },

        getNewTokenFunction: async () => {
          try {
            const res = await ICDservices.getICDToken();
            return res?.data?.token || null;
          } catch (err) {
            return null;
          }
        },
      };

      // try {
      //   await ECT.Handler.configure(settings, callbacks);

      //   interval = setInterval(() => {
      //     const input = document.querySelector(`[data-ctw-ino="${iNo}"]`);
      //     const windowDiv = document.querySelector(
      //       `.ctw-window[data-ctw-ino="${iNo}"]`
      //     );

      //     if (input && windowDiv && !input.disabled) {
      //       clearInterval(interval);
      //       if (isMounted) {
      //         ECT.Handler.bind(iNo);
      //       }
      //     }
      //   }, 500);
      // } catch (err) {
      //   console.error("ECT Configuration Error:", err);
      // }
      await ECT.Handler.configure(settings, callbacks);
      ECT.Handler.bind(iNo);
    };

    configureECT();

    return () => {
      isMounted = false;
      clearInterval(interval);
      ECT.Handler.clear(iNo); // 💥 cleanup on unmount
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex justify-center items-center bg-[#017C7180] z-[1201]">
      <div className="relative h-[90%] w-[70%] bg-white rounded-[20px]">
        <div
          className="absolute top-5 right-8 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>
        <div className="h-[90%] mt-8 overflow-y-scroll p-10">
          <div>
            <label className="block font-semibold mb-2">
              Search Diagnosis:
            </label>
            <input
              type="text"
              className="ctw-input p-2 rounded-[8px] w-full"
              style={{ border: "1px solid #D4D4D4" }}
              autoComplete="off"
              data-ctw-ino={iNo}
            />
            <div className="ctw-window mt-2" data-ctw-ino={iNo}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ECTDiagnosisSearch;
